import { Injectable } from '@angular/core';
import { IItemsListDataFetchResult, IItemsListParameterBase } from '@fi-shared/fi-items-list/fi-items-list';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { IQuizEditItem, IQuizListItem, IQuizViewItem } from '@fi-app/fi-onboarding/fi-quiz/fi-quiz';

@Injectable()
export class FiQuizService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
    ) {}

    getQuizzesListData(parameter: IItemsListParameterBase) {
        const promise = this.fiBackend.fetchDataPost<IItemsListDataFetchResult<IQuizListItem>>(
            'Onboarding/Quiz/GetQuizzesListData',
            parameter,
        );
        return promise;
    }

    getQuizViewer(quizId: number): Promise<IQuizViewItem> {
        return this.fiBackend.fetchDataPost<IQuizViewItem>(`Onboarding/Quiz/GetQuizViewer/${quizId}`);
    }

    saveQuiz(quizItem: IQuizEditItem) {
        const promise = this.fiBackend.fetchDataPost<number>('Onboarding/Quiz/SaveQuiz', quizItem);
        return this.fiLoading.trackPromise(promise);
    }

    getQuiz(quizId: number) {
        return this.fiBackend.fetchDataPost<IQuizEditItem>(`Onboarding/Quiz/GetQuiz/${quizId}`);
    }

    getQuizCopy(quizId: number) {
        return this.fiBackend.fetchDataPost<IQuizEditItem>(`Onboarding/Quiz/GetQuizCopy/${quizId}`);
    }

    deleteQuizzes(quizIds: number[]) {
        const promise = this.fiBackend.fetchDataPost<void>('Onboarding/Quiz/DeleteQuizzes', quizIds);
        return this.fiLoading.trackPromise(promise);
    }
}
